import React from 'react';
import { Container } from 'react-bootstrap';

export default function ContactHeader() {
  return (
    <div style={{ background: '#0a369d', padding: '60px 0' }}>
      <Container className="text-center">
        <h1 className="fw-bold mb-4" style={{ color: "#fff", fontSize: "2.5rem" }}>
          Contactează-ne
        </h1>
        <div
          className="d-inline-block px-4 py-3"
          style={{
            background: 'rgba(0, 24, 77, 0.9)',
            borderRadius: 16,
            maxWidth: 700
          }}
        >
          <span style={{ color: "#fff", fontSize: 18 }}>
            Ai întrebări, sugestii sau vrei să te implici în <span style={{ color: "#FFC72C", fontWeight: 600 }}>proiectele PRDP</span>?<br />
            Scrie-ne și vom reveni cu răspunsuri rapide despre orice inițiativă sau propunere legată de activitatea partidului!
          </span>
        </div>
      </Container>
    </div>
  );
}
